import { Injectable } from '@angular/core';
import { ApiService } from '../../http/api.service';
import { ApiPath } from '../../models/api-path';
import { UserProfileModel, UserRegisterModel } from '../../models/users/user-profile.model';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
  ) { }

  async loadUserProfile(): Promise<UserProfileModel> {
    var profile: UserProfileModel = null!
    const user = await this.apiService.get<UserRegisterModel>(ApiPath.account.profile);
    // const user = this.authService.getUser();
    if (user) {
      profile = {
        email: '',
        firstName: user!.firstName,
        lastName: user!.lastName
      }
      if (profile) {
        this.authService.setUserProfile(profile);
      }
    }

    return profile!;
  }
}
